export const PipeFitingsData=[
    {
    id:1,
    img:require('../Images/Pipefitings/Img1.webp'),
    heading:"Buttweld Pipe Fittings",
    link:'/Buttweld_Pipe_Fittings',                           
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  },
  {
    id:2,
    img:require('../Images/Pipefitings/Bgimg2.jpg'),
    heading:"Threaded Pipe Fittings",
    link:'/Threaded_Pipe_Fittings',
    text:'We stock huge inventories of all our products in all standard sizes to ensure timely delivery.',
  },
  {
    id:3,
    img:require('../Images/Pipefitings/Bgimg1.jpg'),
    heading:"Socket Weld  Pipe Fittings",
    link:"/MGalvanized_Pipe_Fittings",
    text:'All our products go through various quality checks from procurement to final delivery.',
    
  },
  {
    id:3,
    img:require('../Images/Pipefitings/Bgimg3.jpg'),
    heading:"Olets Pipe Fittings",
    link:"/Olets_Pipe_Fittings",
    text:'All our products go through various quality checks from procurement to final delivery.',
    
  },{
    id:3,
    img:require('../Images/ferul_img/img2.jpg'),
    heading:"Ferrule Pipe Fittings",
    link:"/Ferrule_Pipe_Fittings",
    text:'All our products go through various quality checks from procurement to final delivery.',
    
  }]

  export const PipeFitingsGradeData=[
    {
    id:1,
    
    grade:"Buttweld Pipe Fittings",
    link:'/Buttweld_Pipe_Fittings',                           
    
  },
  {
    id:2,
   
    grade:"Threaded Pipe Fittings",
    link:'/Threaded_Pipe_Fittings',
  },
  {
    id:3,
    grade:"Socket Weld  Pipe Fittings",
    link:"/MGalvanized_Pipe_Fittings",
    
  },{
    id:3,
    grade:"Olets Pipe Fittings",
    link:"/Olets_Pipe_Fittings",
    
  },{
    id:3,
    grade:"Ferrule Pipe Fittings",
    link:"/Ferrule_Pipe_Fittings",
    
  }]
  export const  Buttweld_Pipe_Fittings=[{

    heading:"Stainless Steel Buttweld Pipe Fittings",
    grade:[
"SS 304 Buttweld Pipe Fittings",

"SS 304L Buttweld Pipe Fittings",
"SS 304H Buttweld Pipe Fittings",

"SS 316 Buttweld Pipe Fittings",

"SS 316L Buttweld Pipe Fittings",

"SS 316Ti Buttweld Pipe Fittings",

"SS 310 Buttweld Pipe Fittings",

"SS 310S Buttweld Pipe Fittings",

"SS 321 Buttweld Pipe Fittings",

"SS 321H Buttweld Pipe Fittings",

"SS 317 Buttweld Pipe Fittings",

"SS 347 Buttweld Pipe Fittings",

"SS 347H Buttweld Pipe Fittings",
    ]

  },{


    heading:"Alloy Steel Buttweld Pipe Fittings",
    grade:[

    "  Alloy Steel Buttweld Pipe Fittings",

"Nickel Alloys Buttweld Pipe Fittings",

"Nickel 200 Buttweld Pipe Fittings",

"Nickel 201 Buttweld Pipe Fittings",

"Monel 400 Buttweld Pipe Fittings",

"Monel 500 Buttweld Pipe Fittings",

"Inconel 800 Buttweld Pipe Fittings",

"Inconel 825 Buttweld Pipe Fittings",

"Inconel 600 Buttweld Pipe Fittings",

"Inconel 625 Buttweld Pipe Fittings",

"Inconel 601 Buttweld Pipe Fittings",
    ]
  },

  {
    heading:"Carbon Steel ASTM A 234 Buttweld Pipe Fittings",

    grade:[

      "Carbon Steel ASTM A 234 Buttweld Pipe Fittings",
"Hastelloy C 276 Buttweld Pipe Fittings",

"Alloy 20 Buttweld Pipe Fittings",

"Titanium Buttweld Pipe Fittings",

"Duplex Steel 2205 Buttweld Pipe Fittings",

"Copper Alloys Buttweld Pipe Fittings",

"Aluminium Buttweld Pipe Fittings",

"Copper Buttweld Pipe Fittings",

"Brass Buttweld Pipe Fittings",

'Gunmetal Buttweld Pipe Fittings',

    ]
  }


]
export const  Threaded_Pipe_Fittings=[{

  heading:"Stainless Steel Threaded  Pipe Fittings",
  grade:[
"SS 304 Threaded  Pipe Fittings",

"SS 304L Threaded  Pipe Fittings",
"SS 304H Threaded  Pipe Fittings",

"SS 316 Threaded  Pipe Fittings",

"SS 316L Threaded  Pipe Fittings",

"SS 316Ti Threaded  Pipe Fittings",

"SS 310 Threaded  Pipe Fittings",

"SS 310S Threaded  Pipe Fittings",

"SS 321 Threaded  Pipe Fittings",

"SS 321H Threaded  Pipe Fittings",

"SS 317 Threaded  Pipe Fittings",

"SS 347 Threaded  Pipe Fittings",

"SS 347H Threaded  Pipe Fittings",
  ]

},{


  heading:"Alloy Steel Threaded  Pipe Fittings",
  grade:[

  "  Alloy Steel Threaded  Pipe Fittings",

"Nickel Alloys Threaded  Pipe Fittings",

"Nickel 200 Threaded  Pipe Fittings",

"Nickel 201 Threaded  Pipe Fittings",

"Monel 400 Threaded  Pipe Fittings",

"Monel 500 Threaded  Pipe Fittings",

"Inconel 800 Threaded  Pipe Fittings",

"Inconel 825 Threaded  Pipe Fittings",

"Inconel 600 Threaded  Pipe Fittings",

"Inconel 625 Threaded  Pipe Fittings",

"Inconel 601 Threaded  Pipe Fittings",
  ]
},

{
  heading:"Carbon Steel ASTM A 234 Threaded  Pipe Fittings",

  grade:[

    "Carbon Steel ASTM A 234 Threaded  Pipe Fittings",
"Hastelloy C 276 Threaded  Pipe Fittings",

"Alloy 20 Threaded  Pipe Fittings",

"Titanium Threaded  Pipe Fittings",

"Duplex Steel 2205 Threaded  Pipe Fittings",

"Copper Alloys Threaded  Pipe Fittings",

"Aluminium Threaded  Pipe Fittings",

"Copper Threaded  Pipe Fittings",

"Brass Threaded  Pipe Fittings",

'Gunmetal Threaded  Pipe Fittings',

  ]
}


]

export const  Olets_Pipe_Fittings=[{

  heading:"Stainless Steel Olets  Pipe Fittings",
  grade:[
"SS 304 Olets  Pipe Fittings",

"SS 304L Olets  Pipe Fittings",
"SS 304H Olets  Pipe Fittings",

"SS 316 Olets  Pipe Fittings",

"SS 316L Olets  Pipe Fittings",

"SS 316Ti Olets  Pipe Fittings",

"SS 310 Olets  Pipe Fittings",

"SS 310S Olets  Pipe Fittings",

"SS 321 Olets  Pipe Fittings",

"SS 321H Olets  Pipe Fittings",

"SS 317 Olets  Pipe Fittings",

"SS 347 Olets  Pipe Fittings",

"SS 347H Olets  Pipe Fittings",
  ]

},{


  heading:"Alloy Steel Olets  Pipe Fittings",
  grade:[

  "  Alloy Steel Olets  Pipe Fittings",

"Nickel Alloys Olets  Pipe Fittings",

"Nickel 200 Olets  Pipe Fittings",

"Nickel 201 Olets  Pipe Fittings",

"Monel 400 Olets  Pipe Fittings",

"Monel 500 Olets  Pipe Fittings",

"Inconel 800 Olets  Pipe Fittings",

"Inconel 825 Olets  Pipe Fittings",

"Inconel 600 Olets  Pipe Fittings",

"Inconel 625 Olets  Pipe Fittings",

"Inconel 601 Olets  Pipe Fittings",
  ]
},

{
  heading:"Carbon Steel ASTM A 234 Olets  Pipe Fittings",

  grade:[

    "Carbon Steel ASTM A 234 Olets  Pipe Fittings",
"Hastelloy C 276 Olets  Pipe Fittings",

"Alloy 20 Olets  Pipe Fittings",

"Titanium Olets  Pipe Fittings",

"Duplex Steel 2205 Olets  Pipe Fittings",

"Copper Alloys Olets  Pipe Fittings",

"Aluminium Olets  Pipe Fittings",

"Copper Olets  Pipe Fittings",

"Brass Olets  Pipe Fittings",

'Gunmetal Olets  Pipe Fittings',

  ]
}


]




export const  SocketWeld_Pipe_Fittings=[{

  heading:"Stainless Steel SocketWeld Pipe Fittings",
  grade:[
"SS 304 Socket Weld Pipe Fittings",

"SS 304L Socket Weld Pipe Fittings",
"SS 304H Socket Weld Pipe Fittings",

"SS 316 Socket Weld Pipe Fittings",

"SS 316L Socket Weld Pipe Fittings",

"SS 316Ti Socket Weld Pipe Fittings",

"SS 310 Socket Weld Pipe Fittings",

"SS 310S Socket Weld Pipe Fittings",

"SS 321 Socket Weld Pipe Fittings",

"SS 321H Socket Weld Pipe Fittings",

"SS 317 Socket Weld Pipe Fittings",

"SS 347 Socket Weld Pipe Fittings",

"SS 347H Socket Weld Pipe Fittings",
  ]

},{


  heading:"Alloy Steel Socket Weld Pipe Fittings",
  grade:[

  "  Alloy Steel Socket Weld Pipe Fittings",

"Nickel Alloys Socket Weld Pipe Fittings",

"Nickel 200 Socket Weld Pipe Fittings",

"Nickel 201 Socket Weld Pipe Fittings",

"Monel 400 Socket Weld Pipe Fittings",

"Monel 500 Socket Weld Pipe Fittings",

"Inconel 800 Socket Weld Pipe Fittings",

"Inconel 825 Socket Weld Pipe Fittings",

"Inconel 600 Socket Weld Pipe Fittings",

"Inconel 625 Socket Weld Pipe Fittings",

"Inconel 601 Socket Weld Pipe Fittings",
  ]
},

{
  heading:"Carbon Steel ASTM A 234 Socket Weld Pipe Fittings",

  grade:[

    "Carbon Steel ASTM A 234 Socket Weld Pipe Fittings",
"Hastelloy C 276 Socket Weld Pipe Fittings",

"Alloy 20 Socket Weld Pipe Fittings",

"Titanium Socket Weld Pipe Fittings",

"Duplex Steel 2205 Socket Weld Pipe Fittings",

"Copper Alloys Socket Weld Pipe Fittings",

"Aluminium Socket Weld Pipe Fittings",

"Copper Socket Weld Pipe Fittings",

"Brass Socket Weld Pipe Fittings",

'Gunmetal Socket Weld Pipe Fittings',

  ]
}


]

export const CategoriesButtdata=[
 
  {
    img:require("../../Constants/Images/Pipefitings/img5.jpg"),
    heading:"45DegreeElbow",
  },
  {
    img:require("../../Constants/Images/Pipefitings/img6.jpg"),
    heading:"90Degree Elbow",
  },
  {
    img:require("../../Constants/Images/Pipefitings/img7.jpg"),
    heading:"180Degree elbow"
  },
  {
    img:require("../../Constants/Images/Pipefitings/img13.jpg"),
    heading:"Caps",
  },
  {
    img:require("../../Constants/Images/Pipefitings/img16.jpg"),
    heading:"Long & Short Stub Bend",
  },
  {
    img:require("../../Constants/Images/Pipefitings/img9.jpg"),
    heading:"Reducer",
  },
  {
    img:require("../../Constants/Images/Pipefitings/img11.jpg"),
    heading:"Tee",
  },
  
  {
    img:require("../../Constants/Images/Pipefitings/img8.jpg"),
    heading:"Cross"
  }
]
export const ButtweldWeldPipeFittingsData = [
  {
    text1:
      "Buttweld Pipe Fittings Manufacturers,Exporters Suppliers,Importers,Stockists In Mumbai and India.",
    text2:
      "Modi Metals is Manufacturer, Stockists and Supplier of premium quality scope of stainless steel buttweld fittings that are fabricated under the master direction of our persistent workforce. we are 50 years experienced organization in Stainless Steel buttweld fittings. our Stainless Steel buttweld fittings and different items are made utilizing quality material and experience a thorough quality check at all phases of creation to guarantee quality. Outlined in consistence with worldwide quality gauges, these Stainless Steel buttweld fittings are consumption protection, strong and solid. we additionally supply Stainless Steel buttweld fittings in modified size. we are additionally occupied with the produce and conveyance of stainless steel butt welding channel fittings, stainless steel fashioned pipe fittings and stainless steel ribs in India and abroad. we offers a total scope of buttweld and produced pipe fittings, for example, stainless steel reducer, stainless steel elbow, stainless steel tee, stainless steel cross, stainless steel stub closures and stainless steel twists.",
    text3: "",
    grade:Buttweld_Pipe_Fittings,
    Specifications: {
      Material:
        "Stainless Steel ASTM A182 F304, F304L, F306, F316L, F304H, F309S, F309H, F310S, F310H, F316TI, F316H, F316LN, F317, F317L, F321, F321H, F11, F22, F91, F347, F347H, F904L ASTM A312/A403 TP304, TP304L, TP316, TP316L Carbon Steel ASTM A105, A350 LF2, A106 Gr.B, A234 WPB",
      Dimension: "ASME 16.11, MSS SP-79, 83, 95, 97, BS 3799",
      Pressure: "3000LBS, 6000LBS, 9000LBS",
      Size: '1/8"~4" (DN6~DN100)',
    },
    chemical: {
      "ASTM A182 – ASME SA182 –":
        "Standard Specification for Wrought Austenitic Stainless Steel Piping Fittings",
      "ASME B16.9 –": " Factory-Made Wrought Buttwelding Fittings",
      "ASME B16.11 –": "Socket Welding and Threaded Forged Fittings",
      "MSS SP-43 –":
        "Wrought and Fabricated Butt-Welding Fittings for Low Pressure, Corrosion Resistant Applications",
      "MSS SP-95 –": " Swage(d) Nipples and Bull Plugs",
      "BS3799 – ":
        "Specification for Steel pipe fittings, screwed and Socket-welding for the petroleum industry",
    },
  },
];

export const ThreadedPipeFittingsData = [
  {
    text1:
      "Threaded Pipe Fittings Manufacturers,Exporters Suppliers,Importers,Stockists In Mumbai and India.",
    text2:
      "Modi Metals is driving Manufacturer of stainless steel pipe fittings and stainless steel ribs in INDIA since Five Decades,Dipti Metal Industries positions in Top Ten organization in INDIA occupied with assembling of produced pipe fittings, at Dipti Metal Industries we offers the total scope of fashioned fittings including Socket Weld Fittings, Threaded Fittings, Nipple, Branch Outlet Fittings , Bosses, Union Joint and the sky is the limit from there. we would exporter be able to and provider of fashioned attachment weld fittings fabricated in understanding to ASME B16.11. Produced attachment weld fittings are accessible ex-stock in all real stainless steel grades (ASTM A182 F316L, F304L), carbon steel and combination steel grades. We offer different sorts of attachment weld fittings including attachment weld elbow, attachment weld tees, attachment weld cross, and the sky is the limit from there. Attachment weld fittings are broadly utilized as a part of channeling frameworks crosswise over real ventures, for example, petrochemicals, control age, send building, journal industry, distilleries, squander water treatment, compound, pharmaceuticals and others.",
    text3: "",
    grade:Threaded_Pipe_Fittings,
    Specifications: {
      Material:
        "Stainless Steel ASTM A182 F304, F304L, F306, F316L, F304H, F309S, F309H, F310S, F310H, F316TI, F316H, F316LN, F317, F317L, F321, F321H, F11, F22, F91, F347, F347H, F904L ASTM A312/A403 TP304, TP304L, TP316, TP316L Carbon Steel ASTM A105, A350 LF2, A106 Gr.B, A234 WPB",
      Dimension: "ASME 16.11, MSS SP-79, 83, 95, 97, BS 3799",
      Pressure: "3000LBS, 6000LBS, 9000LBS",
      Size: '1/8"~4" (DN6~DN100)',
    },

  },
];

export const SocketWeldPipeFittingsData = [
  {
    text1:
      "Socket Weld Fittings Manufacturers,Exporters Suppliers,Importers,Stockists In Mumbai and India. ",
    text2:
      "Modi metals is driving Manufacturer of stainless steel pipe fittings and stainless steel ribs in INDIA since Five Decades,Dipti Metal Industries positions in Top Ten organization in INDIA occupied with assembling of produced pipe fittings, at Dipti Metal Industries we offers the total scope of fashioned fittings including Socket Weld Fittings, Threaded Fittings, Nipple, Branch Outlet Fittings , Bosses, Union Joint and the sky is the limit from there. we would exporter be able to and provider of fashioned attachment weld fittings fabricated in understanding to ASME B16.11. Produced attachment weld fittings are accessible ex-stock in all real stainless steel grades (ASTM A182 F316L, F304L), carbon steel and combination steel grades. We offer different sorts of attachment weld fittings including attachment weld elbow, attachment weld tees, attachment weld cross, and the sky is the limit from there. Attachment weld fittings are broadly utilized as a part of channeling frameworks crosswise over real ventures, for example, petrochemicals, control age, send building, journal industry, distilleries, squander water treatment, compound, pharmaceuticals and others.",
    text3: "",
    grade:SocketWeld_Pipe_Fittings,
    Specifications: {
      Material:
        "Stainless Steel ASTM A182 F304, F304L, F306, F316L, F304H, F309S, F309H, F310S, F310H, F316TI, F316H, F316LN, F317, F317L, F321, F321H, F11, F22, F91, F347, F347H, F904L ASTM A312/A403 TP304, TP304L, TP316, TP316L Carbon Steel ASTM A105, A350 LF2, A106 Gr.B, A234 WPB",
      Dimension: "ASME 16.11, MSS SP-79, 83, 95, 97, BS 3799",
      Pressure: "3000LBS, 6000LBS, 9000LBS",
      Size: '1/8"~4" (DN6~DN100)',
    },
    chemical: {
      "ASTM A182 – ASME SA182 –":
        "Standard Specification for Wrought Austenitic Stainless Steel Piping Fittings",
      "ASME B16.9 –": " Factory-Made Wrought Buttwelding Fittings",
      "ASME B16.11 –": "Socket Welding and Threaded Forged Fittings",
      "MSS SP-43 –":
        "Wrought and Fabricated Butt-Welding Fittings for Low Pressure, Corrosion Resistant Applications",
      "MSS SP-95 –": " Swage(d) Nipples and Bull Plugs",
      "BS3799 – ":
        "Specification for Steel pipe fittings, screwed and Socket-welding for the petroleum industry",
    },
  },
];

export const oletFittingsData = [
  {
    text1:
      "Olets Fittings Manufacturers,Exporters Suppliers,Importers,Stockists In Mumbai and India.",
    text2:
      "The Olets are made utilizing best quality material and are acknowledged for highlights, for example, dimensional precision and superb solidness. These pipe fittings that are particularly utilized as a part of different ventures for various applications. Attributable to erosion and temperature protection, these olets are utilized as a part of high temperature applications in oil and gas industry.",
    text3: "",
    grade:Olets_Pipe_Fittings,
    Specifications: {
      Material:
        "UNS 2200 (NICKEL 200), UNS 4400 (MONEL 400), UNS 8825 INCONEL (825), UNS 6600 (INCONEL 600), UNS 6601 (INCONEL 601), UNS 6625 (INCONEL 625), UNS 10276 (HASTELLOY C 276), UNS 2201 (NICKEL 201), (ALLOY 20 / 20 CB 3) ",
      Dimension: "ASME 16.11, MSS SP-79, 83, 95, 97, BS 3799",
      Pressure: " 3000 LBS, 6000 LBS & 9000 LBS (Sch40, Sch80/Xs Sch160 Xxs)",
      Size: "1/2''- 24'",
      type:" Weldolet, Sockolet, Nippolet, Threadolet, Latrolet, Flexolet butt-weld, Flexolet Threaded and Sweepolet "
    },
    chemical: {
      "ASTM A182 – ASME SA182 –":
        "Standard Specification for Wrought Austenitic Stainless Steel Piping Fittings",
      "ASME B16.9 –": " Factory-Made Wrought Buttwelding Fittings",
      "ASME B16.11 –": "Socket Welding and Threaded Forged Fittings",
      "MSS SP-43 –":
        "Wrought and Fabricated Butt-Welding Fittings for Low Pressure, Corrosion Resistant Applications",
      "MSS SP-95 –": " Swage(d) Nipples and Bull Plugs",
      "BS3799 – ":
        "Specification for Steel pipe fittings, screwed and Socket-welding for the petroleum industry",
    },
  },
];
export const ThreadedCatgoryData=[

  {
heading:"Threaded Elbow 90 Degree",
img:require('../Images/Pipefitings/ThImg1.jpg'),
  },
  {
    heading:"Threaded Elbow 45 Degree",
    img:require('../Images/Pipefitings/ThImg2.jpg'),
  },
  {
    heading:"Threaded Tee",
    img:require('../Images/Pipefitings/ThImg3.jpg'),
  },
  {
    heading:"Threaded Cross",
    img:require('../Images/Pipefitings/ThImg4.jpg'),
  },
  // {
  //   heading:"Threaded Cross Street",
  //   img:require('../Images/Pipefitings/ThImg1.jpg'),
  // },
  {
    heading:"Threaded Union",
    img:require('../Images/Pipefitings/ThImg5.jpg'),
  },
  {
    heading:"Threaded Coupling",
    img:require('../Images/Pipefitings/Thimg6.jpg'),
  },
  {
    heading:"Threaded Half Coupling",
    img:require('../Images/Pipefitings/ThImg7.jpg'),
  },
  {
    heading:"Threaded Reducing Coupling",
    img:require('../Images/Pipefitings/ThImg8.jpg'),
  },
  {
    heading:"Threaded Cap",
    img:require('../Images/Pipefitings/ThImg9.jpg'),
  },
  {
    heading:"Threaded Hex Head Bushing",
    img:require('../Images/Pipefitings/ThImg10.jpg'),
  },
  {
    heading:"Threaded Square Head Plug",
    img:require('../Images/Pipefitings/ThImg11.jpg'),
  },
  {
    heading:"Threaded Round Head Plug",
    img:require('../Images/Pipefitings/ThImg12.jpg'),
  },
  {
    heading:"Threaded Boss",
    img:require('../Images/Pipefitings/ThImg13.jpg'),
  },
  {
    heading:"Threaded Bull Plug",
    img:require('../Images/Pipefitings/ThImg14.jpg'),
  },
  {
    heading:"Threaded Hex Nipples",
    img:require('../Images/Pipefitings/ThImg15.jpg'),
  },
  {
    heading:"Threaded Swaged Nipples",
    img:require('../Images/Pipefitings/ThImg16.jpg'),
  },
 
      
]



export const OletsCatgoryData=[
  {
    heading:"Weldolet",
img:require('../Images/Pipefitings/Wimg1.jpg'),
  },
  {
    heading:"Sockolet",
img:require('../Images/Pipefitings/Wimg2.jpg'),
  },
  {
    heading:"Threadolet",
img:require('../Images/Pipefitings/Wimg3.jpg'),
  },
  {
    heading:"Elbolet",
img:require('../Images/Pipefitings/Wimg4.jpg'),
  },
  {
    heading:"Flexolet",
img:require('../Images/Pipefitings/Wimg5.jpg'),
  },
  {
    heading:"Latrolet",
img:require('../Images/Pipefitings/Wimg6.jpg'),
  },
  {
    heading:"Sweepolet",
img:require('../Images/Pipefitings/Wimg7.jpg'),
  },
  {
    heading:"Insert Weldolet",
img:require('../Images/Pipefitings/Wimg8.jpg'),
  },
  {
    heading:"Nipolet",
img:require('../Images/Pipefitings/Wimg9.jpg'),
  },
  {
    heading:"Branzolet",
img:require('../Images/Pipefitings/Wimg10.jpg'),
  },{
    heading:"Coupolet",
img:require('../Images/Pipefitings/Wimg11.jpg'),
  },
]




export const SocketCatgoryData=[

  {
heading:"Elbow 90 Degree",
img:require('../Images/Pipefitings/Simg1.jpg'),
  },
  {
    heading:"Elbow 45 Degree",
    img:require('../Images/Pipefitings/Simg2.jpg'),
  },
  {
    heading:"Tee",
    img:require('../Images/Pipefitings/Simg3.jpg'),
  },
  {
    heading:"Cross",
    img:require('../Images/Pipefitings/Simg4.jpg'),
  },
  {
    heading:"Union",
    img:require('../Images/Pipefitings/Simg5.jpg'),
  },
  {
    heading:"Coupling",
    img:require('../Images/Pipefitings/Simg6.jpg'),
  },
  {
    heading:"Capg",
    img:require('../Images/Pipefitings/Simg7.jpg'),
  },
  {
    heading:"Boss",
    img:require('../Images/Pipefitings/Simg9.jpg'),
  },
  {
    heading:"Insert",
    img:require('../Images/Pipefitings/Simg8.jpg'),
  },
]

export const  Ferrule_Pipe_Fittings=[{

  heading:"Stainless Steel Ferrule Pipe Fittings",
  grade:[
"SS 304 Ferrule Pipe Fittings",

"SS 304L Ferrule Pipe Fittings",
"SS 304H Ferrule Pipe Fittings",

"SS 316 Ferrule Pipe Fittings",

"SS 316L Ferrule Pipe Fittings",

"SS 316Ti Ferrule Pipe Fittings",

"SS 310 Ferrule Pipe Fittings",

"SS 310S Ferrule Pipe Fittings",

"SS 321 Ferrule Pipe Fittings",

"SS 321H Ferrule Pipe Fittings",

"SS 317 Ferrule Pipe Fittings",

"SS 347 Ferrule Pipe Fittings",

"SS 347H Ferrule Pipe Fittings",
  ]

},{


  heading:"Alloy Steel Ferrule Pipe Fittings",
  grade:[

  "  Alloy Steel Ferrule Pipe Fittings",

"Nickel Alloys Ferrule Pipe Fittings",

"Nickel 200 Ferrule Pipe Fittings",

"Nickel 201 Ferrule Pipe Fittings",

"Monel 400 Ferrule Pipe Fittings",

"Monel 500 Ferrule Pipe Fittings",

"Inconel 800 Ferrule Pipe Fittings",

"Inconel 825 Ferrule Pipe Fittings",

"Inconel 600 Ferrule Pipe Fittings",

"Inconel 625 Ferrule Pipe Fittings",

"Inconel 601 Ferrule Pipe Fittings",
  ]
},

{
  heading:"Carbon Steel ASTM A 234 Ferrule Pipe Fittings",

  grade:[

    "Carbon Steel ASTM A 234 Ferrule Pipe Fittings",
"Hastelloy C 276 Ferrule Pipe Fittings",

"Alloy 20 Ferrule Pipe Fittings",

"Titanium Ferrule Pipe Fittings",

"Duplex Steel 2205 Ferrule Pipe Fittings",

"Copper Alloys Ferrule Pipe Fittings",

"Aluminium Ferrule Pipe Fittings",

"Copper Ferrule Pipe Fittings",

"Brass Ferrule Pipe Fittings",

'Gunmetal Ferrule Pipe Fittings',

  ]
}


]

export const FerrulePipeFittingsData = [
  {
    text1:
      "Ferrule Fittings Manufacturers,Exporters Suppliers,Importers,Stockists In Mumbai and India. ",
    text2:
      "Modi metals is a leading supplier and stockholder of compression pipe fittings, also known as ferrule fittings in stainless steel 304 and 316 grades. On demand we can also offer ferrule fittings in other grades such as brass, copper, nickel alloys and carbon steel. Double ferrule fittings are require no flaring of the metal tube to install. They are compressed onto the tubing to form strong leak proof connection in process, power and instrumentation applications. Ferrule fittings are ideal for a diverse range of industries, including process oil and gas, petrochemical, power generation, military, pharmaceutical, and more. The single and double ferrule fittings are available in a broad range of sizes, materials, and configurations. Stainless steel ferrule fittings are widely used in hydraulic and pneumatic applications in a range of industries such as oil and gas, petrochemicals, natural gas, fertilizers and power generation.",
    text3: "Ferrule Fittings are pipe fittings that are used to connect two pipes of different material makes. Since welding or threading might not be sufficient to connect these pipes together, a pipe fitting with a ferrule or olive is used to connect them. There are different types such as standard, non – manipulative and flare fittings or manipulative fittings. Pearl Overseas produce all kinds of ferrule fittings for use with different material made pipes. The Brass Ferrule Fittings use brass as the ferrule. It is a connector that can adjust the differences between the two pipes being connected and brass is preferred where corrosive liquids are used. The Stainless Steel Ferrule Fittings are mostly used in hot water and cold water supply lines.",
    grade:Ferrule_Pipe_Fittings,
    Specifications: {
      Material:
        "SS 304,SS 316,Brass,Special Alloy",
      Size: '1/16"OD to 2"OD,OD to 50mm OD',
      Thread: "Thread NPT,BSP,BSPT,UNF",
     "Pressure Rating": '6000PSI for Stainless Steel,300/1000/3000PSI for Brass',
     Type:"Ferrule, Swivel Nut, Adapters",
     Application:"Gas Pipe",
     Connection:"Welded, Male, Female",
     Form:"Hex Nipple, Cap, Elbow",
     "Thread Size":"All",
    
  
    },
    chemical: {
      "Tube to Tube":
        "Straight, Elbow, Tee, Cross, Bulk Head",
      "Tube to Male": "Male Stud, Male Elbow, Male Tee",
      "Female Connector": "Female Straight, Elbow, Tee Positionable Elbow & Tee (Swivel)",
      "Tube Closure":
        "Plug, Cap Weld Connector, Nut & Ferrule Set",

    },
  },
];

export const FerruleCatgoryData=[
  {
    heading:"Back Ferrule",
img:require('../../Constants/Images/ferul_img/img3.jpg'),
  },
  {
    heading:"Reducing Union Tee",
img:require('../../Constants/Images/ferul_img/img4.jpg'),
  }, {
    heading:"Positionable Male Elbow",
img:require('../../Constants/Images/ferul_img/img5.jpg'),
  }, {
    heading:"Female Adaptor",
img:require('../../Constants/Images/ferul_img/img6.jpg'),
  }, {
    heading:"Union Cross",
img:require('../../Constants/Images/ferul_img/img7.jpg'),
  }, {
    heading:"Female Connector",
img:require('../../Constants/Images/ferul_img/img8.jpg'),
  }, {
    heading:"Male Connector",
img:require('../../Constants/Images/ferul_img/img9.jpg'),
  }, {
    heading:"Union Elbow",
img:require('../../Constants/Images/ferul_img/img10.jpg'),
  }, {
    heading:"Fitting And Closer",
img:require('../../Constants/Images/ferul_img/img11.jpg'),
  }, {
    heading:"Reducing Union",
img:require('../../Constants/Images/ferul_img/img12.jpg'),
  }, {
    heading:"Female Run Tee",
img:require('../../Constants/Images/ferul_img/img13.jpg'),
  }, {
    heading:"45 Deg. Male Elbow",
img:require('../../Constants/Images/ferul_img/img14.jpg'),
  }, {
    heading:"Front Ferrule",
img:require('../../Constants/Images/ferul_img/img15.jpg'),
  }, {
    heading:"Male Run Tee",
img:require('../../Constants/Images/ferul_img/img16.jpg'),
  }, {
    heading:"Union",
img:require('../../Constants/Images/ferul_img/img17.jpg'),
  }, {
    heading:"Female Branch Tee",
img:require('../../Constants/Images/ferul_img/img18.jpg'),
  }, {
    heading:"Male Branch Tee",
img:require('../../Constants/Images/ferul_img/img19.jpg'),
  }, {
    heading:"Positionable Male Run Tee",
img:require('../../Constants/Images/ferul_img/img20.jpg'),
  }, {
    heading:"Male Elbow",
img:require('../../Constants/Images/ferul_img/img21.jpg'),
  }, {
    heading:"Reducer",
img:require('../../Constants/Images/ferul_img/img22.jpg'),
  }, {
    heading:"Tube And Closer",
img:require('../../Constants/Images/ferul_img/img23.jpg'),
  }, {
    heading:"Female Manometer Connector",
img:require('../../Constants/Images/ferul_img/img24.jpg'),
  }, {
    heading:"O Seal Male Adaptor",
img:require('../../Constants/Images/ferul_img/img25.jpg'),
  }, {
    heading:"Bulkhead Female Connector",
img:require('../../Constants/Images/ferul_img/img26.jpg'),
  }, {
    heading:"Female Elbow",
img:require('../../Constants/Images/ferul_img/img27.jpg'),
  }, {
    heading:"Male Connector - BSP",
img:require('../../Constants/Images/ferul_img/img28.jpg'),
  }, {
    heading:"Butt Weld Pipe Connector",
img:require('../../Constants/Images/ferul_img/img29.jpg'),
  }, {
    heading:"Bulkhead Union",
img:require('../../Constants/Images/ferul_img/img30.jpg'),
  }, {
    heading:"Nut",
img:require('../../Constants/Images/ferul_img/img31.jpg'),
  }, {
    heading:"Positionable Male Branch Tee",
img:require('../../Constants/Images/ferul_img/img32.jpg'),
  }, {
    heading:"Socket Weld Tube Connector",
img:require('../../Constants/Images/ferul_img/img33.jpg'),
  }, {
    heading:"Socket Weld Tube Elbow",
img:require('../../Constants/Images/ferul_img/img34.jpg'),
  }, {
    heading:"Bulkhead Reducer",
img:require('../../Constants/Images/ferul_img/img35.jpg'),
  }, {
    heading:"Male Adaptor",
img:require('../../Constants/Images/ferul_img/img36.jpg'),
  }, {
    heading:"Bulkhead Male Connector",
img:require('../../Constants/Images/ferul_img/img37.jpg'),
  }, {
    heading:"Female Manometer Adaptor",
img:require('../../Constants/Images/ferul_img/img38.jpg'),
  }, {
    heading:"O Seal Male Connector",
img:require('../../Constants/Images/ferul_img/img39.jpg'),
  }, {
    heading:"45 Deg. Positionable Male Elbow",
img:require('../../Constants/Images/ferul_img/img40.jpg'),
  }, 


]